import { Controller } from "@hotwired/stimulus"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// La zona di caricamento della scheda «Documenti del progetto» (components/readiness/KnowledgeBase.js, 31a5bd1).
// - dragover: sempre preventDefault (il browser non apre il file); drop: preventDefault e, solo con canEdit, i file
//   lasciati vanno nell'input e il form si invia (handleFiles(e.dataTransfer.files)).
// - «Carica documenti» apre la scelta dei file; la scelta invia subito (onChange). Nessun file: nessun invio.
// - durante l'invio (uploading): il Loader2 al posto di Upload, «Analisi AI dei documenti in corso…», pulsante
//   disattivato; alla fine, riuscito o no, il titolo torna, il pulsante torna come lo vuole canEdit e l'input è vuoto
//   (finally dell'originale). Il risultato (toast e pagina riletta, o il toast d'errore) è del server.
// - Nell'originale la richiesta continuava anche lasciando la scheda (la promessa sopravviveva al componente: toast,
//   rilettura e polling). Qui una visita Turbo fermerebbe l'invio del form (navigator.stop): finché la risposta non
//   arriva le visite si fermano (lib/visite_trattenute.js, come turbo/refresh_dopo_invio.js) e l'ultima riparte a fine
//   invio, dopo la pagina riletta del redirect (con ricalcolo=1 se è la stessa pagina dello stesso progetto, così il
//   polling dell'originale resta; alla stessa pagina con action "replace"). Un secondo drop durante l'invio è ignorato:
//   qui un secondo invio annullerebbe il primo (l'originale li mandava insieme).
// - Ogni errore è «Caricamento non riuscito» (catch dell'originale): il server lo manda in Turbo Stream; una risposta
//   d'errore che non è un Turbo Stream (500, pagina del proxy) non si mostra come pagina e, come un errore di rete,
//   dà il toast qui.
const TITOLO = "Trascina i file o carica manualmente"
const IN_CORSO = "Analisi AI dei documenti in corso…"
const ERRORE = "Caricamento non riuscito"
const STREAM = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["form", "input", "icona", "attesa", "titolo", "pulsante"]
  static values = { canEdit: Boolean }

  connect() {
    this.visite = new VisiteTrattenute()
  }

  disconnect() {
    this.visite.rilascia()
  }

  sopra(event) {
    event.preventDefault()
  }

  rilascia(event) {
    event.preventDefault()
    if (!this.canEditValue || this.inVolo) return
    const files = event.dataTransfer?.files
    if (!files?.length) return
    this.inputTarget.files = files
    this.invia()
  }

  scegli() {
    this.inputTarget.click()
  }

  scelti() {
    if (!this.inVolo && this.inputTarget.files?.length) this.invia()
  }

  invia() {
    this.formTarget.requestSubmit()
  }

  inizio(event) {
    if (event.target !== this.formTarget) return
    this.inVolo = true
    this.visite.trattieni()
    this.inCorso(true)
  }

  // La risposta del form è arrivata: la visita del redirect deve passare. Un errore che non è un Turbo Stream non
  // diventa la pagina (requestPreventedHandlingResponse: niente render), il toast lo dà `fine`.
  risposta(event) {
    if (event.target !== this.formTarget) return
    this.visite.lascia()
    const r = event.detail.fetchResponse
    if (r && !r.succeeded && !(r.contentType || "").startsWith(STREAM)) event.preventDefault()
  }

  fine(event) {
    if (event.target !== this.formTarget) return
    const url = this.visite.rilascia()
    this.inVolo = false
    this.inCorso(false)
    this.inputTarget.value = ""
    const { success, fetchResponse } = event.detail
    if (!success && !(fetchResponse?.contentType || "").startsWith(STREAM)) window.toast?.error?.(ERRORE)
    if (url) ripartiDopoInvio(url, success)
  }

  inCorso(si) {
    this.attesaTargets.forEach((el) => el.classList.toggle("hidden", !si))
    this.iconaTargets.forEach((el) => el.classList.toggle("hidden", si))
    if (this.hasTitoloTarget) this.titoloTarget.textContent = si ? IN_CORSO : TITOLO
    if (this.hasPulsanteTarget) this.pulsanteTarget.disabled = si || !this.canEditValue
  }
}

// La visita fermata durante l'invio. Riuscito: dopo la pagina del redirect (turbo:load), con il suo ricalcolo=1 se è la
// stessa pagina dello stesso progetto; altrimenti subito.
function ripartiDopoInvio(url, success) {
  if (!success) return riparti(url)
  document.addEventListener("turbo:load", () => {
    const dest = new URL(url, window.location.href)
    const ora = new URL(window.location.href)
    if (dest.pathname === ora.pathname && ora.searchParams.get("ricalcolo") &&
        dest.searchParams.get("project") === ora.searchParams.get("project")) dest.searchParams.set("ricalcolo", "1")
    riparti(dest.toString())
  }, { once: true })
}
